import React from 'react';
import { useWorkplaceCertificatesQuery } from '../../../../../../graphql/graphql';
import { useManagerContext } from '../../../../Services/ManagerContext';
// @ts-ignore
import styles from './ManagerCertificatesList.module.scss';
import Loading from '../../../../../../Components/Loading';
import ManagerCertificatesListItem from './ManagerCertificatesListItem';

const ManagerCertificatesList: React.FC = () => {
	const { rootWorkplaceId } = useManagerContext();
	const { data, isLoading, refetch } = useWorkplaceCertificatesQuery({
		where: { workplaceId: rootWorkplaceId },
	});

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			{data?.workplaceCertificates?.data?.map((workCert, index) => {
				if (workCert) {
					return (
						<ManagerCertificatesListItem
							item={workCert}
							key={index}
							onReload={refetch}
						/>
					);
				}
			})}
		</div>
	);
};

export default ManagerCertificatesList;
